import { IReleaseNote } from "../types"

export const RELEASE_1_4_1: IReleaseNote = {
    status: "PAST",
    title: "v1.4.1",
    date: "02 September 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "This is a patch release with some minor rewording on our commissioning web form, and some additional FAQs on our 'Learn more' page",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following changes have been added:",
            bullets: [
                "Updated commissioning form to reflect the correct declarations for G99/G98",
                "We have added a 3rd response option of 'N/A' to the commissioning question related to declaring if the single line diagram has changed vs the original submitted with application",
                "New sections added to the FAQ listing: Commissioning, Getting Set Up, Company Search, Workflow Assignment, Comments inline with the 1.4.0 release",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been added:",
            bullets: [
                "Provision of a 3rd accepted response option, value = 'N/A' for the field: isSldSameAsOriginalApplication",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "The following change has been added:",
            bullets: [
                "New sections added to the FAQ listing: Commissioning, Company Search, Workflow Assignment, Comments inline with the 1.4.0 release. ",
            ],
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
